<template>
  <busy-area :busy="loading">
    <div class="flex flex-wrap gap-x-10 gap-y-10 pb-10 pt-5">
      <div v-for="index in tableIndexes" class="flex flex-col justify-stretch">
        <div class="text-body-regular-bold text-table-text-gray uppercase mb-5 text-center">
          {{ $t(`pages.driver.payoutList.creditDebtStatistic.${index}`) }}
        </div>
        <table class="statisticsTable h-full">
          <thead>
            <tr>
              <th class="font-normal">
                (in CHF)
              </th>
              <th>{{ $t('pages.driver.payoutList.creditDebtStatistic.total2') }}</th>
              <th>{{ $t('pages.driver.payoutList.creditDebtStatistic.filtered') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.open') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.open ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.open ?? 0) }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.chargedOpen') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.chargedOpen ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.chargedOpen ?? 0) }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.chargedInPayment') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.chargedInPayment ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.chargedInPayment ?? 0) }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.chargedError') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.chargedError ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.chargedError ?? 0) }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.chargedPaid') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.chargedPaid ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.chargedPaid ?? 0) }}</td>
            </tr>
            <tr>
              <td>{{ $t('pages.driver.payoutList.creditDebtStatistic.total') }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.total?.total ?? 0) }}</td>
              <td>{{ formatNumberForCurrency(statistics?.[index]?.filtered?.total ?? 0) }}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </busy-area>
</template>

<script lang="ts" setup>
import BusyArea from '@utils/busy/BusyArea.vue';
import { formatNumberForCurrency } from '@/utils/helpers';

interface StatisticsItem {
  open: number;
  chargedOpen: number;
  chargedInPayment: number;
  chargedError: number;
  chargedPaid: number;
  credit: number;
  debt: number;
  total: number;
}

interface StatisticTable {
  total: StatisticsItem;
  filtered: StatisticsItem;
}

export interface Statistics {
  credit: StatisticTable;
  debt: StatisticTable;
  creditDebt: StatisticTable;
}

interface Props {
  statistics?: Statistics;
  loading?: boolean;
}

const tableIndexes = ['credit', 'debt', 'creditDebt'];

defineProps<Props>();

</script>

<style lang="scss" scoped>
.statisticsTable {
  @apply border;

  tr {
    td, th {
      &:not(:last-child) {
        @apply border-r;
      }
      @apply px-5 py-2;
      text-align: right;
    }

    th {
      @apply border-b;
    }

    &:last-child {
      td:not(:first-child) {
        border-top: 3px double black;
      }
    }
  }
}
</style>
